import React, {useCallback, useEffect, useState} from 'react';
import {AlbumList} from "../../../components/admin/album/AlbumList";
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../types/PaginationType";
import {ApiQueryParam, ApiService} from "../../../service/ApiService";
import {albumResultCollectionType, albumResultType} from "../../../types/Api/AlbumResultType";
import {albumHydrator} from "../../../models/hydrator/albumHydrator";
import {album} from "../../../models/album";
import {Pagination} from "../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [albums, setAlbums] = useState([] as album[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findAlbum = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'createdAt',
      direction: 'DESC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<albumResultCollectionType> = ApiService.get('/album', apiFilters) as Promise<albumResultCollectionType>;

    result
      .then((r: albumResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setAlbums(r._embedded.albums.map((album: albumResultType) => {
          return albumHydrator.hydrate(album);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setAlbums([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findAlbum();
  }, [findAlbum]);

  return (
    <>
      <BoxTitle title="Gestion des albums photos"/>
      <AlbumList albums={albums} loading={loading} refresh={findAlbum}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/album/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un album
        </NavLink>
      </div>
    </>
  )
}
